import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { AskDataIndexing } from '~src/datasource/models/IDataSourceInfo';

interface AskDataReadingModeProps {
  readonly askDataIndexing: AskDataIndexing;
}

export function AskDataReadingMode(props: AskDataReadingModeProps): JSX.Element {
  const indexingLabelMap = {
    [AskDataIndexing.automatic]: Messages.datasourceAskData_indexing_automatic(),
    [AskDataIndexing.manual]: Messages.datasourceAskData_indexing_manual(),
    [AskDataIndexing.disabled]: Messages.datasourceAskData_indexing_disabled(),
  };

  return (
    <div>
      {Messages.dataSourceNlpSetting_option_Title()}: {indexingLabelMap[props.askDataIndexing]}
    </div>
  );
}
